module.exports = __webpack_public_path__ + "static/fyrstahaedTron-c649926fb1512be4e61c5d9b77badb1e.png";